export default "__VITE_ASSET__BtUvo3e5__"